import {
  AppBar,
  Box,
  Button,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenSelect from '../../../global_components/KenSelect';
import KenLoader from '../../../Components/KenLoader/index';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import { useState, useEffect } from 'react';
import KenAutoComplete from '../../../global_components/KenAutoComplete';
import moment from 'moment';
import {
  getCurrentBatch,
  getBatchFilter,
  getAcademicFilter,
  getAccountData,
} from '../../../Utils/apiServices';

const arrayBreadCrumb = [
  { head: 'HOME', url: routes.academicsPlanner },
  {
    head: 'CURRENT BATCHES',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    height: '28px',
    width: '78px',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  dateField: {
    backgroundColor: '#fff',
  },
  filterBox: {
    display: 'flex',
    gap: 10,
  },
  filterBox2: {
    justifyContent: 'end',
    position: 'absolute',
    right: 0,
    bottom: 0,
    display: 'flex',
    gap: 3,
  },
}));

const selectOptions = [
  {
    label: 'Filter by Program',
    value: 'Filter by Program',
  },
  {
    label: 'Filter by Batch',
    value: 'Filter by Batch',
  },
  {
    label: 'Filter by Intake',
    value: 'Filter by Intake',
  },
  {
    label: 'Filter by Campus',
    value: 'Filter by Campus',
  },
  {
    label: 'Filter by Term Status',
    value: 'Filter by Term Status',
  },
];

const CurrentProgrammes = () => {
  const history = useHistory();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [selectCampusValue, setCampusValue] = useState({
    title: '',
    value: '',
  });
  const [selectTermValue, setTermValue] = useState({ title: '', value: '' });
  const [selectProgramValue, setProgramValue] = useState({
    title: '',
    value: '',
  });
  const [selectBatchValue, setBatchValue] = useState({ title: '', value: '' });
  const [selectIntakeValue, setIntakeValue] = useState({
    title: '',
    value: '',
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectIntakeOptions, setIntakeOptions] = useState([
    { title: 'JAN', value: 'JAN' },
    { title: 'FEB', value: 'FEB' },
    { title: 'MAR', value: 'MAR' },
    { title: 'APR', value: 'APR' },
    { title: 'MAY', value: 'MAY' },
    { title: 'JUN', value: 'JUN' },
    { title: 'JUL', value: 'JUL' },
    { title: 'AUG', value: 'AUG' },
    { title: 'SEP', value: 'SEP' },
    { title: 'OCT', value: 'OCT' },
    { title: 'NOV', value: 'NOV' },
    { title: 'DEC', value: 'DEC' },
  ]);
  const [selectBatchOptions, setBatchOptions] = useState([
    { title: '2015', value: '2015' },
    { title: '2016', value: '2016' },
    { title: '2017', value: '2017' },
    { title: '2018', value: '2018' },
    { title: '2019', value: '2019' },
    { title: '2020', value: '2020' },
    { title: '2021', value: '2021' },
    { title: '2022', value: '2022' },
    { title: '2023', value: '2023' },
    { title: '2024', value: '2024' },
    { title: '2025', value: '2025' },
    { title: '2026', value: '2026' },
    { title: '2027', value: '2027' },
    { title: '2028', value: '2028' },
    { title: '2029', value: '2029' },
    { title: '2030', value: '2030' },
    { title: '2031', value: '2031' },
    { title: '2032', value: '2032' },
    { title: '2033', value: '2033' },
    { title: '2034', value: '2034' },
    { title: '2035', value: '2035' },
    { title: '2036', value: '2036' },
    { title: '2037', value: '2037' },
    { title: '2038', value: '2038' },
    { title: '2039', value: '2039' },
    { title: '2040', value: '2040' },
  ]);
  const [selectProgramOptions, setProgramOptions] = useState([]);
  const [selectCampusOptions, setCampusOptions] = useState([
    { title: 'Singapore', value: 'Singapore' },
    { title: 'Dubai', value: 'Dubai' },
    { title: 'Mumbai', value: 'Mumbai' },
    { title: 'Sydney', value: 'Sydney' },
    { title: 'All', value: 'All' },
  ]);
  const [selectTermOptions, setTermOptions] = useState([
    { title: 'Ongoing', value: 'Ongoing' },
    { title: 'Upcoming', value: 'Upcoming' },
    { title: 'All', value: 'All' },
  ]);

  const ActionCell = (row) => {
    const { id, index } = row.row;
    return (
      <Box>
        <Button
          size="small"
          variant="contained"
          color="primary"
          style={{ borderRadius: 15 }}
          // component={Link}
          onClick={() => {
            history.push({
              pathname: `${routes.academicCalendar}`,
            });
            let AcademicProgram = JSON.stringify({
              title: row.data[index]?.data?.Course,
              value: row.data[index]?.data?.Course,
            });
            let ProgramPlan = JSON.stringify({
              title: row.data[index]?.data?.ProgramName,
              value: row.data[index]?.data?.ProgramPlanRecordId,
            });
            sessionStorage.setItem('AcademicProgram', AcademicProgram);
            sessionStorage.setItem(
              'programPlanID',
              row.data[index]?.data?.ProgramPlanRecordId
            );
            sessionStorage.setItem('ProgramPlan', ProgramPlan);
            sessionStorage.setItem('intake', row.data[index].intake);
            sessionStorage.setItem('year', row.data[index].batch);
          }}
        >
          View Details
        </Button>
      </Box>
    );
  };

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'batch',
      accessor: 'batch',
      disableGlobalFilter: true,
    },
    {
      Header: 'intake',
      accessor: 'intake',
      disableGlobalFilter: true,
    },
    {
      Header: 'mode',
      accessor: 'mode',
      disableGlobalFilter: true,
    },
    {
      Header: 'Start Date',
      accessor: 'start_date',

      Cell: (props) => {
        const custom_date =
          props.value != 'N/A' ? moment(props.value).format('DD-MM-YYYY') : '-';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },

      disableGlobalFilter: true,
    },
    {
      Header: 'End Date',
      accessor: 'end_date',

      Cell: (props) => {
        const custom_date =
          props.value != 'N/A' ? moment(props.value).format('DD-MM-YYYY') : '-';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },

      disableGlobalFilter: true,
    },
    {
      Header: 'No of Student',
      accessor: 'no_of_student',
      disableGlobalFilter: true,
    },
    {
      Header: 'Terms',
      accessor: 'semester',
      disableGlobalFilter: true,
    },
    {
      Header: 'Term Status',
      accessor: 'status',
      disableGlobalFilter: true,
    },
    {
      Header: 'Campus',
      accessor: 'campus',
      disableGlobalFilter: true,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ActionCell,
    },
  ];

  const datas = [
    {
      id: 1,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          MBA
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/01/2020',
      end_date: '31/12/2022',
      no_of_student: 450,
      semester: '3',
      campus: 'Mumbai',
      batch: 'MBA 2022',
      status: 'Ongoing',
    },
    {
      id: 2,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          EMBA
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/06/2022',
      end_date: '31/05/2022',
      no_of_student: 320,
      semester: '3',
      campus: 'Singapore',
      batch: 'EMBA 2022',
      status: 'Completed',
    },
    {
      id: 3,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          GMBA
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/06/2021',
      end_date: '31/05/2022',
      no_of_student: 235,
      semester: '2',
      campus: 'Mumbai',
      batch: 'GMBA 2022',
      status: 'Upcoming',
    },
    {
      id: 4,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          PGPFMB
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/01/2020',
      end_date: '31/06/2022',
      no_of_student: 232,
      semester: '4',
      campus: 'Dubai',
      batch: 'PGPFMB 2022',
      status: 'Ongoing',
    },
  ];
  const handleSelectChange = () => {
    setSelectValue('');
    setCampusValue({
      title: '',
      value: '',
    });
    setTermValue({
      title: '',
      value: '',
    });
    setProgramValue({
      title: '',
      value: '',
    });
    setBatchValue({
      title: '',
      value: '',
    });
    setIntakeValue({
      title: '',
      value: '',
    });
    setData([]);
    sessionStorage.setItem('AcademicProgram', '');
    sessionStorage.setItem('year', '');
    sessionStorage.setItem('intake', '');
  };
  const handleSelectCampusChange = (e, objval) => {
    setTermValue({
      title: '',
      value: '',
    });
    // const campus = e.target.innerHTML;
    if (objval !== null) {
      setCampusValue({
        title: objval.title,
        value: objval.value,
      });
    } else {
      setCampusValue({
        title: '',
        value: '',
      });
    }
  };
  const handleSelectTermChange = (e, objval) => {
    if (objval !== null) {
      setTermValue({
        title: objval.title,
        value: objval.value,
      });
    } else {
      setTermValue({
        title: '',
        value: '',
      });
    }
  };
  const handleSelectProgramChange = (e, options, objval) => {
    setSelectValue('');
    setCampusValue({
      title: '',
      value: '',
    });
    setTermValue({
      title: '',
      value: '',
    });
    setBatchValue({
      title: '',
      value: '',
    });
    setIntakeValue({
      title: '',
      value: '',
    });
    if (objval !== null) {
      setProgramValue({
        title: objval.title,
        value: objval.value,
      });
      let academicProgramObj = JSON.stringify({
        title: objval.title,
        value: objval?.value,
        id: objval?.academicProgramID,
      });
      sessionStorage.setItem('AcademicProgram', academicProgramObj);
      // const programID = JSON.parse(academicProgramObj) || options.filter((item) => item.value === e.target.value);
      // sessionStorage.setItem('programPlanID', programID?.id);
    } else {
      setProgramValue({
        title: '',
        value: '',
      });
    }
  };
  const handleSelectBatchChange = (e, objval) => {
    setIntakeValue({
      title: '',
      value: '',
    });
    setCampusValue({
      title: '',
      value: '',
    });
    setTermValue({
      title: '',
      value: '',
    });
    if (objval !== null) {
      setBatchValue({
        title: objval.title,
        value: objval.value,
      });
      let yearObj = JSON.stringify({
        title: objval.title,
        value: objval?.value,
      });
    } else {
      setBatchValue({
        title: '',
        value: '',
      });
    }
  };
  const handleSelectIntakeChange = (e, objval) => {
    setCampusValue({
      title: '',
      value: '',
    });
    setTermValue({
      title: '',
      value: '',
    });
    if (objval !== null) {
      // setIntakeValue(e.target.value);
      setIntakeValue({
        title: objval.title,
        value: objval.value,
      });
      let intakeObj = JSON.stringify({
        title: objval.title,
        value: objval?.value,
      });
    } else {
      setIntakeValue({
        title: '',
        value: '',
      });
    }
  };
  const manageStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const manageEndDate = (e) => {
    setEndDate(e.target.value);
  };
  useEffect(() => {
    getAccountData().then((res) => {
      console.log('res');
      console.log(res);

      if (res.recentItems.length > 0) {
        const data = res?.recentItems.filter((item) => {
          if (item.Name === 'SP Jain School of Global Management') {
            return item;
          } else {
            return item;
          }
        });
        let SPJain = {
          attributes: {
            type: 'Account',
            url: '/services/data/v54.0/sobjects/Account/0011y00000P7qFEAAZ',
          },
          Id: '0011y00000P7qFEAAZ',
          Name: 'SP Jain School of Global Management',
        };
        console.log('data');
        console.log(data);
        localStorage.setItem('userDetails', JSON.stringify(SPJain));
      }
    });
  }, []);

  useEffect(() => {
    let academicProgram = sessionStorage.getItem('AcademicProgram');
    let year = sessionStorage.getItem('year');
    let intake = sessionStorage.getItem('intake');
    if (academicProgram && year && intake) {
      let program = JSON.parse(academicProgram);
      let year2 = { title: year, value: year };
      let intake2 = { title: intake, value: intake };
      setProgramValue(program);
      setIntakeValue(intake2);
      setBatchValue(year2);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    let programVal = selectProgramValue?.title;
    if (programVal != '') {
      let querry2 = {
        termStatus:
          selectTermValue.value === 'All' ? '' : selectTermValue.value || '',
        campus:
          selectCampusValue.value === 'All'
            ? ''
            : selectCampusValue.value || '',
        intake: selectIntakeValue.value || '',
        program: selectProgramValue.title || '',
        batch: selectBatchValue.value || '',
      };
      getCurrentBatch(querry2)
        .then((res) => {
          let data = [];
          res.map((item, index) => {
            data.push({
              id: index + 1,
              program: item.ProgramName ? item.ProgramName : 'N/A',
              intake: item.Intake ? item.Intake : 'N/A',
              mode: item.Mode ? item.Mode : 'N/A',
              start_date: item.TermStartDate,
              end_date: item.TermEndDate,
              no_of_student: item.NoOfStudent ? item.NoOfStudent : 'N/A',
              semester: item.Semester ? item.Semester : 'N/A',
              campus: item.Campus ? item.Campus : 'N/A',
              batch: item.Batch ? item.Batch : 'N/A',
              status: item.TermStatus ? item.TermStatus : 'N/A',
              data: item,
            });
          });
          const numAscending = [...data].sort((a, b) => a.batch - b.batch);
          setData(numAscending);
          setLoading(false);
        })
        .catch((err) => {
          setData([]);
          setLoading(false);
        });
    }
    setLoading(false);
  }, [
    selectCampusValue,
    selectTermValue,
    selectProgramValue,
    selectBatchValue,
    selectIntakeValue,
  ]);
  useEffect(() => {
    // let querry = `program=${selectProgramValue}&batch=JAN&intake=2023`;
    getBatchFilter().then((res) => {
      if (res.length > 0) {
        let data = [...new Set(res.map((item) => item.ProgramName))];
        let programData = data.map((item) => ({ label: item, value: item }));
        // let data = [...new Set(res.map((item) => item.Course))];
        // let programData = data.map((item) => ({ label: item, value: item }));

        let data2 = [...new Set(res.map((item) => item.Batch))];
        // let batchData = data2.map((item) => ({ label: item, value: item }));

        let data3 = [...new Set(res.map((item) => item.Intake))];
        // let intakeData = data3.map((item) => ({ label: item, value: item }));
        let data4 = [...new Set(res.map((item) => item.Campus))];
        let campusData = data4.map((item) => ({ label: item, value: item }));

        let data5 = [...new Set(res.map((item) => item.TermStatus))];
        let statusData = data5.map((item) => ({ label: item, value: item }));
        // let data5 = [...new Set(res.map((item) => item?.TermStatus))];
        // let statusData = data5.map((item) => ({ label: item, value: item }));
        let updateStatus = statusData.filter((ele) => ele.label);
        console.log('updateStatus', updateStatus);

        // setIntakeOptions(intakeData);
        // setBatchOptions(batchData);
        // setProgramOptions(programData);
        setCampusOptions(campusData);
        setTermOptions(updateStatus);
      }
    });
  }, [selectProgramOptions]);
  useEffect(() => {
    getAcademicFilter().then((res) => {
      let programData = [];
      Object.entries(res['Academic Program']).map(([item, keyVal]) => {
        programData.push({
          title: item,
          value: item,
          academicProgramID: keyVal?.id,
        });
      });
      setProgramOptions(programData);
    });
  }, []);
  const CustomStyle = {
    option: (base, state) => {
      let backgroundColor = 'white';

      if (state.isSelected) {
        backgroundColor = 'red';
      }

      if (state.isFocused) {
        backgroundColor = 'blue';
      }

      return {
        ...base,
        backgroundColor,
      };
    },
  };
  return (
    <Box>
      {loading && <KenLoader />}
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Current Batches
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid container className={classes.mainActions}>
        <Grid item xs={8} style={{ alignItems: 'center' }}>
          {selectValue === 'Filter by Date' && (
            <>
              <Typography style={{ marginLeft: 10 }}>Start Date</Typography>
              <Box sx={{ backgroundColor: '#fff' }} ml={2}>
                <KenDateTimePicker
                  value={startDate}
                  type="date"
                  required={true}
                  defaultValue={startDate}
                  onChange={manageStartDate}
                />
              </Box>
              <Typography style={{ marginLeft: 10 }}>End Date</Typography>
              <Box sx={{ maxWidth: 160, backgroundColor: '#fff' }} ml={2}>
                <KenDateTimePicker
                  value={endDate}
                  type="date"
                  required={true}
                  defaultValue={endDate}
                  onChange={manageEndDate}
                />
              </Box>
            </>
          )}
          <Box className={classes.filterBox}>
            <div className="accal">
              <KenAutoComplete
                name="Select Academic Program"
                options={selectProgramOptions}
                label="Select Academic Program"
                value={selectProgramValue}
                onChange={(e, value) =>
                  handleSelectProgramChange(e, selectProgramOptions, value)
                }
                required={true}
                multiple={false}
              />
            </div>
            <div className="accal">
              <KenAutoComplete
                name="Select Academic Program"
                label="Select Batch"
                options={selectBatchOptions}
                value={selectBatchValue}
                onChange={(e, value) => handleSelectBatchChange(e, value)}
                required={true}
                multiple={false}
              />
            </div>
            <div className="accal">
              <KenAutoComplete
                label="Select Intake"
                options={selectIntakeOptions}
                value={selectIntakeValue}
                // onChange={handleSelectIntakeChange}
                onChange={(e, value) => handleSelectIntakeChange(e, value)}
                required={true}
                multiple={false}
              />
            </div>
            <div className="accal">
              <KenAutoComplete
                label="Select Campus"
                options={selectCampusOptions}
                value={selectCampusValue}
                // onChange={handleSelectCampusChange}
                onChange={(e, value) => handleSelectCampusChange(e, value)}
                required={true}
                multiple={false}
              />
            </div>
            <div className="accal">
              <KenAutoComplete
                label="Select Term Status"
                options={selectTermOptions}
                value={selectTermValue}
                onChange={(e, value) => handleSelectTermChange(e, value)}
                required={true}
                multiple={false}
              />
            </div>
          </Box>
        </Grid>
        <Grid item xs={4} style={{ position: 'relative' }}>
          <Box className={classes.filterBox2}>
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              color="primary"
              className={classes.addButton}
              component={Link}
              to={routes.addProgram}
            >
              Add New Program
            </Button>
            &nbsp;
            <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              onClick={handleSelectChange}
            >
              Clear All
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box className="cardlsitbox">
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={data}
            pagination={{ disabled: false }}
            toolbarDisabled={true}
            initialState={{
              hiddenColumns: ['id'],
            }}
          />
        </KenCard>
      </Box>
    </Box>
  );
};

export default CurrentProgrammes;
